import { scrollToSection } from "./Navbar";

export default function Footer() {
  return (
    <footer className="bg-[#0A1128] text-white border-t border-white/10 px-6 md:px-12 lg:px-24 pt-20 pb-10" data-testid="site-footer">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
        <div className="md:col-span-5">
          <img src="/fam-logo.png" alt="FAM Job Consultancy" className="h-14 w-auto mb-6" />
          <p className="text-white/50 font-light leading-relaxed max-w-sm text-sm">
            FAM Job Consultancy Private Limited — connecting companies with skilled professionals and helping candidates build careers they're proud of.
          </p>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.25em] text-white/40 mb-6">Explore</h4>
          <div className="flex flex-col gap-3">
            {[["jobs", "Job Search"], ["services", "Services"], ["industries", "Industries"], ["resources", "Career Resources"], ["contact", "Contact"]].map(([id, label]) => (
              <button key={id} onClick={() => scrollToSection(id)} className="text-left text-sm text-white/70 hover:text-white transition-colors" data-testid={`footer-link-${id}`}>
                {label}
              </button>
            ))}
          </div>
        </div>
        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.25em] text-white/40 mb-6">Contact</h4>
          <div className="text-sm text-white/70 space-y-2">
            <p>64 Banshankari, Bengaluru, Karnataka, India</p>
            <p>+91 60028 28049</p>
            <p>info@famjobconsultancy.com</p>
            <p>www.famjobconsultancy.com</p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
        <span>© {new Date().getFullYear()} FAM Job Consultancy Private Limited. All rights reserved.</span>
        <a href="/admin" className="hover:text-white/70 transition-colors" data-testid="footer-admin-link">Admin Login</a>
      </div>
    </footer>
  );
}
